import { useEffect, useState } from "react";
import { request, debounce } from "../utils/index";
import { emailRule, ERROR_MESSAGE } from "../const";
import { setSetting, send } from "../service";
import { isLite } from "../lite";

export const SSO = ({ form, setSaveLogin }) => {

  const [email, setEmail] = useState(form.email || "")
  const [complete, setComplete] = useState(false)
  const [valid, setValid] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isNotExist, setIsNotExist] = useState(false)

  const disabled = !(emailRule.test(email) && email)

  function back() {
    setSaveLogin({ ...form, email });
    setSetting({ isSSO: false });
  }

  function checkEmail(email, notExist = false) {
    !notExist && setComplete(!!email);
    !notExist && setValid(emailRule.test(email));
    setIsNotExist(notExist);
    let element = document.getElementById(`lable-input-email-sso`)
    if (!email) {
      element.classList.add('input-requried')
      element.classList.remove('input-has', 'input-error')
    } else if (!emailRule.test(email)) {
      element.classList.add('input-error')
      element.classList.remove('input-requried', 'input-has')
    } else {
      element.classList.add('input-has')
      element.classList.remove('input-requried', 'input-error')
    }
    return !email || !emailRule.test(email)
  }

  useEffect(() => {
    if (!form.email) {
      return;
    }
    const emailInput = document.getElementById(`lable-input-email-sso`);
    emailInput.value = form.email;
    emailInput.dispatchEvent(new Event("blur"));
    checkEmail(form.email);
  }, [form.email]);

  function SSOLogin() {
    if (disabled) { return }
    setLoading(true);

    function timeoutCb() {
      send({ action: 'apiMessage', type: "error", message: ERROR_MESSAGE });
    }
    function resloveSSO(resSSO) {
      if (resSSO.code === 200) {
        send({ action: 'navigate', url: resSSO.data })

      } else if (resSSO.code === 500) {
        setLoading(false);
        checkEmail("", true);
      } else {
        let msg = resSSO.message
        if (msg) {
          msg = msg.charAt(0).toUpperCase() + msg.slice(1)
        }
        setLoading(false);

        send({ action: 'apiMessage', type: "error", message: msg || 'Fail to login' })
      }
    }

    debounce(() => {
      const params = {
        url: '/command-center/sso/oauth2/login/url',
        data: {
          email,
          clientType: "WEB",
          isVerify: false
        },
        method: 'post',
        reslove: resloveSSO,
        timeoutCb
      }
      request(params)
    }, 10, true)
  }
  
  return (<div style={{
    width: 290, padding: "32px",
    position: "relative",
    background: "#fff",
    height: 466,
    boxSizing: "border-box",
    borderRadius: 8,
    width: 354,
    boxShadow: "0px 4px 10px -2px rgba(16, 24, 40, 0.1), 0px 0px 4px -2px rgba(16, 24, 40, 0.05)"
  }}>
    <div className="right-title"
      style={{ marginBottom: "90px 0 38px", marginTop: isNotExist ? 77.5 : 93.5, fontSize: 18, whiteSpace: "nowrap"}}>
      Login to Trucker Path<br/>{isLite ? "NavPro" : "COMMAND"} with Single Sign-On</div>
    <div style={{ position: "relative" }} className="each-input-con">
      <input className="input email" autoComplete="new-password"

        onInput={(e) => {
          setEmail(e.target.value)
          checkEmail(e.target.value.trim())
        }}
        onBlur={e => {
          setEmail(e.target.value.trim())
          checkEmail(e.target.value.trim())
        }}
        maxLength="512" id="lable-input-email-sso" />
      <label htmlFor="lable-input-email-sso" className="input-label">Email Address</label>
      {!complete && <div className="form-error form-requried"
        style={{ visibility: "visible!important" }}>
        Please complete this required field</div>}
      {complete && !valid &&
        <div className="form-error" style={{ visibility: "visible" }}>
          Invalid email format</div>}
      {isNotExist &&
        <div className="form-error" style={{ visibility: "visible" }}>
          Your account is currently not set up for SSO. Please log in with your COMMAND credentials.</div>}
    </div>
    {loading ? <div className="common-loading submit-btn" style={{    marginTop: isNotExist ? 56 : 24}}>
      <div className="loading-icon"></div>
    </div> :
      <div className="submit-btn" id="submit-btn-forget" onClick={SSOLogin}
        style={{
          background: !disabled ? "#4066D4" : "#DADCE1",
          marginTop: isNotExist ? 56 : 24,
          cursor: !disabled ? "pointer" : "not-allowed"
        }}>
        LOGIN
      </div>}
    <a className="back-login" style={{ left: 82 }} onClick={back} >Log in with {isLite ? "NavPro" : "COMMAND"} account</a>
  </div>)
}